<template lang="pug">
  .input-password
    v-flex
      input-text(
        :id="inputKey"
        value=value
        v-model="password"
        :label="label"
        :icon-append="show ? 'visibility' : 'visibility_off'"
        :type="show ? 'text' : 'password'"
        :rules="getRules"
        :required="required"
        :max-length="maxlength"
        @icon-click="changeShow()"
        color="black"
      )
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';

export default {
  name: 'InputPassword',
  components: {
    InputText,
  },
  props: {
    inputKey: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      default: 'Senha',
    },
    required: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    minLength: {
      type: Number,
      default: 0,
    },
    maxlength: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      show: false,
      rulesNative: {
        required: value => !!value || this.$t('support.components.inputs.required'),
        minLength: value => (!!value && value.length >= this.minLength)
          || this.$t('support.components.inputs.minLength', { length: this.minLength }),
      },
    };
  },
  computed: {
    password: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    getRules() {
      const rules = [];
      if (this.required) rules.push(this.rulesNative.required);
      if (this.minLength) rules.push(this.rulesNative.minLength);
      return rules.concat(this.rules);
    },
  },
  methods: {
    changeShow() {
      this.show = !this.show;
    },
  },
};
</script>
